<template>
  <div class="deal-grid text-sm font-medium text-text-secondary rounded py-3-5 items-center -mt-px group">
    <div class="text-text-ternary font-normal">
      {{ $moment.unix(deal.created_at).format('DD.MM.YY HH:mm') }}
    </div>
    <div class="flex items-center">
      <AssetIcon :instrument="deal.instrument" class="mr-3 -my-px"/>
      <div class="truncate">{{ deal.instrument.ticker }}</div>
      <NoteEdit :id="deal.id"
                :note="deal.note"/>
    </div>
    <AssetType :asset-type="deal.instrument.type"/>
    <EventType :deal_type="deal.type"/>
    <div class="text-right">{{ deal.amount }}</div>
    <div class="text-right">
      {{ displayCurrencyValue(deal.price, dealCurrency, true) }}
    </div>
    <div class="text-right">
      {{ displayCurrencyValue(commissionsSum, dealCurrency, true) }}
    </div>
    <div class="text-right">
      {{ displayCurrencyValue(deal.sum_full_base, {}, false) }}
    </div>
    <div>
      <!--      <IconDotsMore class="ml-4"/>-->
    </div>
  </div>
</template>

<script>
import AssetIcon from "@/components/cabinet/Investments/InvestmentAssets/InvestmentAssetItem/AssetIcon";
import IconDotsMore from "@/components/icons/IconDotsMore";
import EventType from "@/components/cabinet/Investments/InvestmentDeals/DealListItem/EventType";
import AssetType from "@/components/cabinet/Investments/InvestmentDeals/DealListItem/AssetType";
import NoteEdit from "@/components/cabinet/Investments/InvestmentDeals/DealListItem/NoteEdit";
import {mapGetters} from "vuex";

export default {
  name: "DealsListItem",
  components: {NoteEdit, AssetType, EventType, IconDotsMore, AssetIcon},
  props: {
    deal: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['getCurrencyByCode', 'displayCurrencyValue']),
    dealCurrency() {
      return this.getCurrencyByCode(this.deal.instrument.currency);
    },
    commissionsSum() {
      return this.deal.commission_broker + this.deal.commission_clearing + this.deal.commission_exchange;
    }
  }
}
</script>